export const postersListSession2 = [
  {
    id: "Poster 4",
    title: "Smart biosupercapacitors for intelligent medical implants.",
    authors: [
      "Leyanet Piedra Llanes",
      "Angel de Jesus Zuniga Camporredondo",
      "Cinthia Janeth Pecina Hernandez",
      "Roxana Berlanga Perez",
      "Brad Daichi Suwaki Lopez",
      "Carlo Florentino Vazquez Patino",
      "Jorge Alexis Zuniga Martinez",
      "Raul Lucio Porto."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 19",
    title: "Controlled exfoliation of molybdenum trioxide nanosheets for their application as electrodes in supercapacitors.",
    authors: [
      "Perez Gutierrez Gres Estefania",
      "Ana Karina Cuentas G",
      "Noé Díaz de León",
      "Jassiel Rodríguez"
    ],
    affiliations: []
  },
  {
    id: "poster 24",
    title: "Melanin–Iron oxide-based composites and their potential application as Supercapacitor electrode material.",
    authors: [
      "Martha Luz Paniagua-Chavez",
      "Alvaro de Jesus Ruiz-Baltazar",
      "Jorge Roberto Oliva-Uc",
      "Rocio Meza-Gordillo",
      "Rosa Isela Cruz Rodriguez."
    ],
    affiliations: []
  },
  {
    id: "poster 25",
    title: "Smart supercapacitors as electrochemical actuators based on activated carbon and Graphene.",
    authors: [
      "Vicente Patricio Rodríguez Reyes",
      "Roxana Berlanga Pérez",
      "Brad Daichi Suwaki Lopez",
      "Angel de Jesus Zúñiga Camporredondo",
      "Jorge Alexis Zúñiga Martínez",
      "Raúl Lucio Porto"
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 33",
    title: "Pulse electrodeposition of MnO2 on Graphene Substrates for Microsupercapacitors.",
    authors: [
      "Carlos Ramírez Morán",
      "Roxana Berlanga Pérez",
      "Johanna García Montemayor",
      "Jorge Alexis Zúñiga Martínez",
      "Raúl Lucio Porto."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 34",
    title: "Hofmann-Type Metal Organic Frameworks as Versatile Precursors for Faradaic Electrodes in Hybrid Supercapacitors.",
    authors: [
      "Paula Andrea Ojeda Girata",
      "Próspero Acevedo Peña",
      "Vianney Aguilar Vargas",
      "José Antonio Irán Díaz Góngora",
      "Edilso Francisco Reguera Ruiz."
    ],
    affiliations: [
      "IPN- Nacional, Laboratorio Nacional de Conversión y Almacenamiento de Energía, CICATA",
      "SECIHTI-IPN"
    ]
  },
  {
    id: "poster 40",
    title: "Inducing Faradaic Behavior in Layered VOPO4 by Intercalation of Redox Moecules for Fast Electrochemical Energy Storage.",
    authors: [
      "Antonio Garcia-Montes Emilio",
      "Roxana Berlanga Pérez",
      "Johanna García Montemayor",
      "Jorge Alexis Zuñiga",
      "Raúl Lucio Porto."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 43",
    title: "Nanostructure-based α-MnO2 electrodes for applications in hybrid supercapacitors.",
    authors: [
      "Alvaro Ortiz-Perez",
      "Jhonathan Castillo-Saenz",
      "Benjamin Valdez-Salas",
      "Eduardo Estrada-Movilla",
      "Ernesto Beltran-Partida",
      "Jorge Salvador-Carlos."
    ],
    affiliations: ["UABC-Mexicali-Chemistry and Advanced Materials- Instituto de Ingeniería"]
  },
  {
    id: "poster 46",
    title: "Graphene and δ-MnO2 functionalized with Alizarin Red S for Asymmetric Supercapacitors.",
    authors: [
      "Cesar Alan Gonzalez Wallmark",
      "Roxana Berlaga Perez",
      "Johanna Garcia Montemayor",
      "Javier Osvaldo Teran Carlin",
      "Jorge Alexis Zuniga Martinez",
      "Raul Lucio Porto."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 48",
    title: "Fabrication of Electrodes for a Hybrid Supercapacitor Based on Nickel Phosphate Nanosheets on Laser-Structured Carbon Nanotube and Graphene Oxide Surfaces.",
    authors: ["Jasive Ximena Pérez Velázquez."] ,
    affiliations: []
  },
  {
    id: "poster 61",
    title: "2D Quantum Dots Transition Metal Oxide/Graphene Nanocomposites for Electrochemical Microcapacitors.",
    authors: [
      "Roxana Berlanga Pérez",
      "Johanna García Montemayor",
      "Carlos Ramírez Morán",
      "Jorge Alexis Zúñiga Martínez",
      "Raúl Lucio Porto."
    ],
    affiliations: ["UANL"]
  },
  {
    id: "poster 69",
    title: "Synthesis and Electrochemical Evaluation of Cation-Intercalated δ-MnO₂ Thin Films from CVD MnxOy and their Performance as Aqueous Supercapacitors.",
    authors: [
      "Perla Judith Perez Diaz",
      "Yasmin Esqueda-Barron",
      "Jose Martin Baas Lopez",
      "Ana Karina Cuentas-Gallegos",
      "Daniella Esperanza Pacheco-Catalan."
    ],
    affiliations: [
      "Centro de Investigación Científica de Yucatán-México.",
      "CICESE",
      "CNyN-UNAM"
    ]
  },
  {
    id: "poster 70",
    title: "Modifying δ-MnO2 with Conductive Polymers and CNTs for its Application in Electrochemical Supercapacitators.",
    authors: [
      "Javier Osvaldo Teran Carlin", "Roxana Berlanga Perez", "Johanna Garcia Montemayor", "Cesar Alan Gonzalez Wallmark", "Jorge Alexis Zuniga Martinez", "Raul Lucio Porto"
    ],
    affiliations: [
      "UANL"
    ]
  },
  {
    id: "poster 77",
    title: "Exploring the configurational entropy transition on SrRuO3 system to cationic co-doping for supercapacitors electrodes materials.",
    authors: [
      "Alvarez J.",
      "Montañez-MolinaM.",
      "Celaya C.",
      "Cruz-Jáueregui M.",
      "Solórzano M."
    ],
    affiliations: ["UABC-Facultad de Ciencias.", "CNyN-UNAM."]
  },
  {
    id: "Poster 1",
    title: "Correlation between Morphology, Crystal Size Distribution and γ-Fe2O3 content with electrochemical performance of iron oxide-carbon Nanocomposite.",
    authors: [
      "Michel Montanez Molina",
      "Prospero Acevedo Pena",
      "Mario Humberto Farias",
      "Yasmin Esqueda Barron",
      "Javier Alonso Lopez Medina",
      "Ana Karina Cuentas Gallegos."
    ],
    affiliations: ["CICESE"]
  },
  {
    id: "poster 8",
    title: "Engineering NiCo2O4-CNT Heterostructures for Noble-Metal-Free Ethylene Glycol Fuel Cells.",
    authors: [
      "Suárez Barajas A.",
      "Ramos Castillo C.",
      "Martin Martinez M. Olivas A.",
      "Guerra Blcazar M.",
      "Alvarez Contreras L.",
      "Arjona N."
    ],
    affiliations: [
      "CIDETEQ, Qro",
      "CNyN-UNAM",
      "UAQ-Facultad de Ingeniería-División de Investigación y Posgrado",
      "CIMAV-Chihuahua"
    ]
  },
  {
    id: "poster 22",
    title: "Sustainable Fabrication of Electrodes via Laser Treatment for Energy Storage Applications.",
    authors: [
      "Yasmín Esqueda Barrón",
      "Perla Judith Pérez Díaz",
      "Santiago Camacho López",
      "Ana Karina Cuentas Gallegos."
    ],
    affiliations: ["CICESE"]
  },
  {
    id: "poster  31",
    title: "Synthesis, Structural Characterization, and Electrochemical Evaluation of a Hybrid Cathode Material Based on LiMn₂O₄ and LiFePO₄ for Lithium-Ion Batteries.",
    authors: [
      "Cristopher Mondragón",
      "Axel Torres",
      "Enrique Quiroga-González",
      "Oswaldo Sánchez-Dena."
    ],
    affiliations: ["UACJ", "IFIS-BUAP"]
  },
  {
    id: "poster 39",
    title: "Insitu Raman Spectroscopy Study of Structural Reorganization in Carbonaceous Materials during Ionic Intercalation.",
    authors: [
      "Rojas Castillo G.",
      "Mendoza Figueroa J. Ramos Sanchez G."
    ],
    affiliations: [
      "UAM-Iztapalapa-Department of Process Engineering and Hydraulics",
      "SECIHITI-Posdoctoral Fellowships"
    ]
  },
  {
    id: "poster 51",
    title: "Contributing to the Mexican Lithium Supply Chain: from Li extraction in clays toward the recycling of spent Li-ion batteries.",
    authors: [
      "Axel Torres",
      "Cristopher Mondragón",
      "Cesar Manuel Chavira",
      "Rosselyn Sánchez",
      "Enrique Quiroga-González",
      "Oswaldo Sánchez-Dena"
    ],
    affiliations: ["UACJ", "BUAP-Institute of Physics"]
  },
  {
    id: "poster 55",
    title: "Recovery and conditioning of cathode material from spent lithium-ion batteries.",
    authors: [
      "Daniel Balleza",
      "Sergio Perez Sicairos",
      "Julio Cesar Calva Yañez."
    ],
    affiliations: [
      "TecNM/I.T. Tijuana Centro de Graduados e Investigación en Química",
      "SECIHTI-TecNM/I.T. Tijuana Centro de Graduados e Investigación en Química."
    ]
  },
  {
    id: "poster 60",
    title: "Nitrogen- and boron-doped carbon nanoparticles for lithium-ion storage.",
    authors: [
      "Marco Vinicio Rodriguez Barreras",
      "Jassiel Rolando Rodriguez Barreras",
      "Rodrigo Ponce Perez."
    ],
    affiliations: ["CICESE", "CNyN-UNAM"]
  },
  {
    id: "poster 62",
    title: "Biochars derived from sugarcane waste as potential battery electrodes.",
    authors: [
      "Zyanya Alexa Quintero Aguilar",
      "Ezequiel De la Llave",
      "Diana Cristina Martinez Casillas."
    ],
    affiliations: [
      "ENES Juriquilla-UNAM-QRO",
      "Instituto de Química Física de los Materiales, Medio Ambiente y Energía (INQUIMAE), Consejo Nacional de Investigaciones Científicas y Técnicas (CONICET). Facultad de Ciencias Exactas y Naturales, Universidad de Buenos Aires (UBA), Argentina"
    ]
  },
  {
    id: "poster 63",
    title: "Nitrogen Functionalization of Activated rGO Derived from Spent LiBs for Supercapacitor Applications.",
    authors: [
      "S. F. Rojas Vargas",
      "P. Acevedo Peña",
      "M. Gónzalez Montiel",
      "V. Aguilar Vargas",
      "J.A.I. Diaz Góngora",
      "E. Reguera."
    ],
    affiliations: [
      "IPN- Laboratorio Nacional de Conversión y Almacenamiento de Energía.",
      "CICATA-Legaria.",
      "SECIHTI-IPN-Laboratorio Nacional de Conversión y Almacenamiento de Energía. CICATA-Legaria"
    ]
  },
  {
    id: "poster 67",
    title: "Fabrication and Evaluation of an Electrode Based on Spaced Carbon Nanotubes on Conductive Substrates.",
    authors: [
      "Francisco Javier De La Rosa Acevedo",
      "José Manuel Romo Herrera",
      "Hugo Jesús Tiznado Vázquez",
      "Jassiel Rolando Rodriguez Barreras",
      "Ana Karina Cuentas Gallegos."
    ],
    affiliations: ["CNyN-UNAM", "CICESE"]
  },
  {
    id: "Poster 84",
    title: "Design, obtention and study of spin crossover materials with potentialities in energy harvesting.",
    authors: [
      "M.C. Vázquez Rodríguez",
      "Y. Avila García",
      "E.F. Reguera Ruíz."
    ],
    affiliations: [
      "Centro de Investigación en Ciencia Aplicada y Tecnología Avanzada-Legaria.",
      "Instituto Politécnico Nacional."
    ]
  },
  {
    id: "poster 14",
    title: "Hard Carbon expansion for Na ion Batteries.",
    authors: [
      "Jeshua Alejandro Ramírez Moreno",
      "Enrique Quiroga González."
    ],
    affiliations: []
  }
];

